import CustomForm from "../Util/Form/CustomForm/CustomForm";
import CustomFormContainer from "../Util/Form/CustomForm/CustomFormContainer";
import config from "../../../../application/config/config";
import Fetch from "../../../util/core/Fetch";
import { getUserSession } from "../../../util/core/Session";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import sleep from "sleep-promise";

function Form() {
  const session = getUserSession();
  const [formContent, setFormContent] = useState(<>Carregando...</>);
  const id = session.user.id;

  const { core_application_instance_id } = useParams();

  const endpointBackend = config.endpoints.backend;

  const paths = {
    endpointSave: endpointBackend + "core/loginconfigs/editloginconfigs",
    endpointGetById: endpointBackend + "core/loginconfigs/getloginconfigs",
  };

  let labelTitle = "Configurações Tela de Login";

  const currentURL = window.location.href;

  const getForm = (values) => {
    const form = {
      labelTitle: labelTitle,
      validateOnChange: true,
      showGoBackButton: !!core_application_instance_id,
      hiddenValues: {
        core_application_instance_id
      },
      id: id,
      fields: [
        {
          name: "title",
          type: "text",
          label: "Título",
          validations: {},
          columnSize: 12,
        },
        {
          name: "subtitle",
          type: "text",
          label: "Subtitulo",
          validations: {},
          columnSize: 12,
        },
        {
          name: "form_position",
          type: "select",
          options: [
            { label: "Esquerda", value: "LEFT" },
            { label: "Direita", value: "RIGHT" },
          ],
          label: "Posição do Formulário",
          validations: {
            required: true
          },
          columnSize: 12,
        },
        {
          name: "url",
          type: "text",
          label: "URL",
          validations: {
            required: true,
          },
          columnSize: 12,
        },
        {
          name: "logo_img",
          type: "fileS3",
          label: "Logo Tela de Login .png 500x500",
          uploadPath: "/users/photos/",
          extensionAccept: ".jpeg,.jpg,.png",
          limitFileSize: 5,
          validations: {},
          columnSize: 12,
        },
        {
          name: "favicon_img",
          type: "fileS3",
          label: "Nav icon .ico",
          uploadPath: "/users/photos/",
          extensionAccept: ".ico",
          limitFileSize: 5,
          validations: {},
          columnSize: 12,
        },
        {
          name: "logo_menu_img",
          type: "fileS3",
          label: "Logo Menu .png 500x500",
          uploadPath: "/users/photos/",
          extensionAccept: ".jpeg,.jpg,.png",
          limitFileSize: 5,
          validations: {},
          columnSize: 12,
        },
        {
          name: "isotype_img",
          type: "fileS3",
          label: "Isotipo .png 500x500",
          uploadPath: "/users/photos/",
          extensionAccept: ".jpeg,.jpg,.png",
          limitFileSize: 5,
          validations: {},
          columnSize: 12,
        },
        {
          name: "background_img",
          type: "fileS3",
          label: "Fundo .png 960x1024",
          uploadPath: "/users/photos/",
          extensionAccept: ".jpeg,.jpg,.png",
          limitFileSize: 100,
          validations: {},
          columnSize: 12,
        },
        {
          name: "banner_overlay_opacity",
          type: "integer",
          label: "Opacidade Overlay %",
          validations: {
            required: false,
          },
          columnSize: 2,
        },
        {
          name: "primary_color",
          type: "color",
          label: "Cor Primária",
          validations: {
            required: false,
          },
          columnSize: 12,
        },
        {
          name: "banner_primary_color",
          type: "color",
          label: "Cor Overlay Banner",
          validations: {
            required: false,
          },
          columnSize: 12,
        },
        {
          name: "terms_condition_show",
          type: "radioGroup",
          label: "Termos e condições",
          options: [
            {
              label: "Sim",
              value: "1",
              selected: true,
            },
            {
              label: "Não",
              value: "0",
            },
          ],
          handleChange: async (element, field, values) => {
            values.terms_condition_text = "";
            let form = getForm(values);
            setFormContent(<></>);
            await sleep(1);
            setFormContent(<CustomFormContainer form={form} content={<CustomForm form={form} />} />);
          },
          validations: {
            required: false,
          },
          columnSize: 12,
        },
        values.terms_condition_show === "1"
          ? {
            name: "terms_condition_text",
            type: "richText",
            label: "Termos e condições",
            validations: {},
            columnSize: 12,
          }
          : {},
        {
          name: "password_validation",
          type: "radioGroup",
          label: "Validar senha",
          options: [
            {
              label: "Sim",
              value: "1",
            },
            {
              label: "Não",
              value: "0",
              selected: true,
            },
          ],
          handleChange: async (element, field, values) => {
            values.password_validation_type = "medium";
            let form = getForm(values);
            setFormContent(<></>);
            await sleep(1);
            setFormContent(<CustomFormContainer form={form} content={<CustomForm form={form} />} />);
          },
          validations: {
            required: false,
          },
          columnSize: 12,
        },
        values.password_validation === "1"
          ? {
            name: "password_validation_type",
            type: "select",
            options: [
              { label: "Fácil", value: "easy" },
              { label: "Médio", value: "medium" },
              { label: "Difícil", value: "hard" },
            ],
            label: "Dificultade da validação de senha",
            validations: {
              required: false,
            },
            columnSize: 12,
          } : {},
        {
          name: "has_copyright",
          type: "radioGroup",
          options: [
            {
              label: "Sim",
              value: "1",
            },
            {
              label: "Não",
              value: "0",
              selected: true,
            },
          ],
          label: "Exibir mensagem de Copyright",
          validations: {
            required: false,
          },
          columnSize: 12,
          handleChange: async (element, field, values) => {
            let form = getForm(values);
            setFormContent(<></>);
            await sleep(1);
            setFormContent(<CustomFormContainer form={form} content={<CustomForm form={form} />} />);
          }
        },
        values.has_copyright === "1"
          ? {
            name: "copyright",
            type: "text",
            label: "Texto a ser exibido para Copyright",
            validations: {
              required: values.has_copyright === "1",
            },
            columnSize: 12
          } : {},
      ],
      customValidators: {},
      ...paths,
    };

    form.values = values;
    return form;
  };

  useEffect(() => {
    const load = async () => {
      let values = {};

      if (core_application_instance_id) {
        values = await Fetch.post(paths.endpointGetById, { formLoginConfigs: true, core_application_instance_id });
      } else if (id) {
        values = await Fetch.post(paths.endpointGetById, { urlVa: currentURL });
      }

      const form = getForm(values);
      setFormContent(<CustomFormContainer form={form} content={<CustomForm form={form} />} />);
    };
    load();
  }, []);

  return <div>{formContent}</div>;
}
export default Form;
